var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"footer"},[_c('div',{staticClass:"container-link"},_vm._l((_vm.$t('enlaces.contacto')),function(el,key){return _c('a',{key:key,attrs:{"href":el,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(key))])}),0),_vm._v(" "),_c('span',[_vm._v("\n\t\t"+_vm._s(_vm.$t('enlaces.copyright'))+"\n\t")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c625485e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/footer.vue
// module id = null
// module chunks = 